import { createSelector } from 'reselect';
import get from 'lodash/get';
import { graphDataOrEmptyObjectSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

export const selectCurrentGoal = createSelector(
  graphDataOrEmptyObjectSelector,
  graphDataOrEmpty => {
    return get(graphDataOrEmpty, HOME_PURCHASE_GOAL_GRAPH_NODE) || {};
  },
);

export const nullablePropertyNameSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphDataOrEmpty => get(graphDataOrEmpty, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.Name`, null),
);
